import axios from 'axios';
import { getApiHost } from '../utils/getApiHost';

/**
 * Post-auth backend touchpoint. Provisions the MongoDB user + Stripe customer
 * for first-time users and is a no-op for returning users (idempotent on the
 * backend). Safe to call after every successful sign-in or sign-up.
 */
export const confirmUserSignup = async (token: string): Promise<void> => {
  await axios.post(
    `${getApiHost()}/user/signup`,
    {},
    { headers: { Authorization: `Bearer ${token}` } }
  );
};
